import { PlannerMultiple } from 'mixs/orders/planner';

class HistoriesPlanner extends PlannerMultiple {
}

riot.mixin('histories.planner', HistoriesPlanner as riot.TagMixin)
